// extracted by mini-css-extract-plugin
module.exports = {"globalSpin":"globalSpin_3r-eq","fa-spin":"fa-spin_kB5I4"};